import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=99a1c10c&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports